import styled from "styled-components";

export default styled.span`
	font-family: Jost;
	color: #888888;
	font-size: 10px;
	margin-left: 10px;
	margin-top: 3px;
`;
